"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupOrderItems = groupOrderItems;
/**
 * Groups order items by product (aisleCode|productName), placing
 * the purchase item first and any return items underneath.
 * Preserves insertion order of the first occurrence of each group.
 */
function groupOrderItems(items) {
    const groups = new Map();
    for (const item of items) {
        const key = `${item.aisleCode}|${item.productName}`;
        if (!groups.has(key)) {
            groups.set(key, { key, purchase: null, refunds: [] });
        }
        const group = groups.get(key);
        if (item.isReturn) {
            group.refunds.push(item);
        }
        else {
            group.purchase = item;
        }
    }
    return Array.from(groups.values());
}
